<div class="tab-pane" role="tabpanel" id="ampliacion">
    <fieldset id="agregar_ampliacion" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <h3 class="form-signin-heading"><strong>Autorizaciones Especiales</strong></h3>
                        <hr>
                        <div class="form-horizontal">
                            <div class="form-group" align="left">
                                <!-- <label for="autorizacion" class="col-md-2" style="padding-top: 10px;">AUTORIZACIONES ESPECIALES:</label> -->
                                <div class="col-md-2">
                                    <mat-checkbox formControlName="autorizacion1" id="autorizacion1" name="autorizacion1" (change)="add_autorizacion()" value="SI">Art. 121 LGUC</mat-checkbox>
                                </div>
                                <div class="col-md-2">
                                    <mat-checkbox formControlName="autorizacion2" id="autorizacion2" name="autorizacion2" (change)="add_autorizacion()" value="SI">Art. 122 LGUC</mat-checkbox>
                                </div>
                                <div class="col-md-2">
                                    <mat-checkbox formControlName="autorizacion3" id="autorizacion3" name="autorizacion3" (change)="add_autorizacion()" value="SI">Art. 123 LGUC</mat-checkbox>
                                </div>
                                <div class="col-md-2">
                                    <mat-checkbox formControlName="autorizacion4" id="autorizacion4" name="autorizacion4" (change)="add_autorizacion()" value="SI">Art. 124 LGUC</mat-checkbox>
                                </div>
                                <div class="col-md-2" style=" width: 90px;" *ngIf= "!encontrado">
                                    <mat-checkbox formControlName="autorizacion5" id="autorizacion5" name="autorizacion5" (change)="add_autorizacion()" value="SI" style="padding-right : 0px ">Art. 55</mat-checkbox>
                                </div>
                                <div class="col-md-2">
                                    <mat-checkbox formControlName="autorizacion6" id="autorizacion6" name="autorizacion6" (change)="add_autorizacion()" value="SI">Otro (Especificar)</mat-checkbox>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div> 
        </div>
    </fieldset>
</div>   